module.exports = __webpack_public_path__ + "img/Solera Galvanizada.f5619374.jpg";